module.exports = __webpack_public_path__ + "img/Result_Advanced_0608_01.d89a8764.png";